const concatUntilEmpty = arr => {
  if (!arr) return '';
  let end = arr.findIndex(el => !el);
  if (end < 0) end = arr.length;
  return arr.slice(0, end).join('');
};
const checkClipboardPermissions = async () => {
  try {
    if (!navigator.clipboard || !navigator.permissions) {
      return false;
    }
    const permission = await navigator.permissions.query({
      name: 'clipboard-write'
    });
    return permission.state === 'granted';
  } catch (error) {
    return false;
  }
};

export { checkClipboardPermissions, concatUntilEmpty };
